// @flow
import { createSelector } from 'reselect';
import type { GlobalState } from '../rootReducer';

/* reducer */
const DEFAULT_STATE = {};

export type State = {
    ...typeof DEFAULT_STATE,
};

export default function reducer(state: State = DEFAULT_STATE, action: any = {}) {
    switch (action.type) {
        default:
            return state;
    }
}

/* SELECTORS */
const stateSelector = (state: GlobalState) => state.config;

export const getBaseUrl: GlobalState => string = createSelector(stateSelector, state => state.baseUrl || '');
export const getBuildNumber: GlobalState => string = createSelector(stateSelector, state => state.buildNumber || '');
export const getClassicBaseUrl: GlobalState => string = createSelector(
    stateSelector,
    state => state.classicBaseUrl || ''
);
export const getCuratorBaseUrl: GlobalState => string = createSelector(
    stateSelector,
    state => state.curatorImgUrl || ''
);
export const getDeployment: GlobalState => string = createSelector(stateSelector, state => state.deployment || '');
export const getGlobalNotificationClientType: GlobalState => string = createSelector(
    stateSelector,
    state => state.globalNotificationClientType || ''
);
export const getGoogleApiKey: GlobalState => string = createSelector(stateSelector, state => state.googleApiKey || '');
export const getPubnubSubscribeKey: GlobalState => string = createSelector(
    stateSelector,
    state => state.pubNubSubscribeKey || ''
);
export const getPubnubNotificationsSubscribeKey: GlobalState => string = createSelector(
    stateSelector,
    state => state.pubNubNotificationsSubscribeKey || ''
);
export const getPushSubscriptionPublicKey: GlobalState => string = createSelector(
    stateSelector,
    state => state.pushSubscriptionPublicKey
);
export const getSailthruCustomerId: GlobalState => string = createSelector(
    stateSelector,
    state => state.sailthruCustomerId || ''
);
export const getSegmentWriteKey: GlobalState => string = createSelector(
    stateSelector,
    state => state.segmentWriteKey || ''
);
export const getSoastaMPulseApiKey: GlobalState => string = createSelector(
    stateSelector,
    state => state.soastaMPulseApiKey || ''
);
export const getStripePublishKey: GlobalState => string = createSelector(
    stateSelector,
    state => state.stripePublishKey || ''
);
export const getReferralCandy: GlobalState => string = createSelector(
    stateSelector,
    state => state.referralCandy || ''
);
export const getUseFullstory: GlobalState => boolean = createSelector(
    stateSelector,
    state => state.useFullstory || false
);
export const getWWWBaseUrl: GlobalState => string = createSelector(stateSelector, state => state.wwwBaseUrl || '');
export const getHelpScoutInformation: GlobalState => any = createSelector(
    stateSelector,
    state => state.helpScout || {}
);
